export const HISTORY_LIST = 1;
export const HISTORY_DETAILS = 2;
export const HISTORY_SUMMARY = 3;
